<div class="cipafacil-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="cipafacil-vertical-navigation-header">
        <ng-content select="[cipafacilVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="cipafacil-vertical-navigation-content overflow-menu"
        #navigationContent>

        <!-- Content header -->
        <div class="cipafacil-vertical-navigation-content-header">
            <ng-content select="[cipafacilVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <cipafacil-vertical-navigation-aside-item
                    *ngIf="item.type === 'aside'"
                    [item]="item"
                    [name]="name"
                    [activeItemId]="activeAsideItemId"
                    [autoCollapse]="autoCollapse"
                    [skipChildren]="true"
                    (click)="toggleAside(item)"></cipafacil-vertical-navigation-aside-item>

                <!-- Basic -->
                <cipafacil-vertical-navigation-basic-item
                    *ngIf="item.type === 'basic'"
                    [item]="item"
                    [name]="name"></cipafacil-vertical-navigation-basic-item>

                <!-- Collapsable -->
                <cipafacil-vertical-navigation-collapsable-item
                    *ngIf="item.type === 'collapsable'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></cipafacil-vertical-navigation-collapsable-item>

                <!-- Divider -->
                <cipafacil-vertical-navigation-divider-item
                    *ngIf="item.type === 'divider'"
                    [item]="item"
                    [name]="name"></cipafacil-vertical-navigation-divider-item>

                <!-- Group -->
                <cipafacil-vertical-navigation-group-item
                    *ngIf="item.type === 'group'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></cipafacil-vertical-navigation-group-item>

                <!-- Spacer -->
                <cipafacil-vertical-navigation-spacer-item
                    *ngIf="item.type === 'spacer'"
                    [item]="item"
                    [name]="name"></cipafacil-vertical-navigation-spacer-item>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="cipafacil-vertical-navigation-content-footer">
            <ng-content select="[cipafacilVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="cipafacil-vertical-navigation-footer">
        <ng-content select="[cipafacilVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<div
    class="cipafacil-vertical-navigation-aside-wrapper"
    *ngIf="activeAsideItemId"
    cipafacilScrollbar
    [cipafacilScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
    [@fadeInLeft]="position === 'left'"
    [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'"
    [@fadeOutRight]="position === 'right'">

    <!-- Items -->
    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Aside -->
            <cipafacil-vertical-navigation-aside-item
                *ngIf="item.type === 'aside' && item.id === activeAsideItemId"
                [item]="item"
                [name]="name"
                [autoCollapse]="autoCollapse"></cipafacil-vertical-navigation-aside-item>

        </ng-container>

    </ng-container>

</div>
